import Circle from "./circle"

const DisabledSlot = () => {
    return (
        <div>
            <Circle radius={5} borderColor="#D3D3D3" borderStyle="solid" backgroundColor="#D3D3D3" character="" />
        </div>
    )
}

export default DisabledSlot;